import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utilities';

const initalState = {
    data: [],
    loading: false,
    deleting: false,
    posted: false,
    error: null,
    fileDeleted: false,
    deletingFile: false,
    uploaded: false,
    errorDeletingFile: null,
    progress: 0.0
};

const reducer = (state = initalState, action) => {
    switch (action.type) {
        // Add
        case actionTypes.EDUCATION_ADD_INIT:
            return updateObject(state, { loading: false, posted: false, error: null });

        case actionTypes.EDUCATION_ADD_START:
            return updateObject(state, { loading: true });

        case actionTypes.EDUCATION_ADD_SUCCESS:
            const newEducation = updateObject(action.data, { id: action.id });
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
                data: state.data.concat(newEducation)
            });

        case actionTypes.EDUCATION_ADD_FAIL:
            return updateObject(state, { loading: false, posted: false, error: action.error });

        // Update
        case actionTypes.EDUCATION_UPDATE_SUCCESS:
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
            });

        
        // Fetch
        case actionTypes.EDUCATION_FETCH_START:
            return updateObject(state, { loading: true });

        case actionTypes.EDUCATION_FETCH_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });

        case actionTypes.EDUCATION_FETCH_FAIL:
            return updateObject(state, { loading: false, error: action.error });


        // Find by ID
        case actionTypes.EDUCATION_FINDBYID_START:
            return updateObject(state, { loading: true });

        case actionTypes.EDUCATION_FINDBYID_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });
        case actionTypes.EDUCATION_FINDBYID_FAIL:
            return updateObject(state, { loading: false, error: action.error });


        // Delete
        case actionTypes.EDUCATION_DELETE_START:
            return updateObject(state, { deleting: true, });

        case actionTypes.EDUCATION_DELETE_SUCCESS:
            return updateObject(state, { deleting: false });

        case actionTypes.EDUCATION_DELETE_FAIL:
                return updateObject(state, { deleting: false, error: action.error });

        
        // Upload
        case actionTypes.EDUCATION_UPLOADFILE_START:
            return updateObject(state, { uploaded: false });

        case actionTypes.EDUCATION_UPLOADFILE_PROGRESS:
            return updateObject(state, { progress: action.progress });

        case actionTypes.EDUCATION_UPLOADFILE_SUCCESS:
            return updateObject(state, { uploaded: true, progress: 0.0 });

        case actionTypes.EDUCATION_UPLOADFILE_FAIL:
            return updateObject(state, { uploaded: false, error: action.error });

        case actionTypes.EDUCATION_DELETE_FILE_START:
            return updateObject(state, { deletingFile: true });

        case actionTypes.EDUCATION_DELETE_FILE_SUCCESS:
            return updateObject(state, { fileDeleted: true, deletingFile: false });

        case actionTypes.EDUCATION_DELETE_FILE_FAIL:
            return updateObject(state, { deletingFile: false, errorDeletingFile: action.errorDeletingFile });

        default:
            return state;
    }
};

export default reducer;